"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpointMapping = void 0;
exports.endpointMapping = {
    prod: {
        apiKey: 'b5WQXyHhitakF9Ye3o0m91tUo7Te1h4e5Wro5Qa2',
        endpoint: 'https://carol.cruise-api.aida.de',
    },
    test: {
        apiKey: 'SugaHtKv9f1UZU6SJoHnu9rqNUy1U0Tna6XAurRE',
        endpoint: 'https://test-carol.cruise-api.aida.de',
    },
};
//# sourceMappingURL=client.js.map